/**
 * Utility functions for user-related operations
 */

/**
 * Check if a user has a specific permission
 * @param {Object} user - The user object
 * @param {string} permission - The permission to check for
 * @returns {boolean} - True if user has the permission, false otherwise
 */
export const hasPermission = (user, permission) => {
  if (!user?.permissions) {
    return false;
  }
  const permissions = user.permissions.split(',').map(p => p.trim());
  return permissions.includes(permission);
};
